import { useEffect } from 'react';
import type { UseModalBehaviorParams } from '../types';

const useModalBehavior = ({ isOpen, onClose, modalRef }: UseModalBehaviorParams): void => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    const modalDialog = modalRef.current;
    if (!(isOpen && modalDialog)) {
      return;
    }

    const stopPropagation = (e: MouseEvent) => e.stopPropagation();
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    modalDialog.addEventListener('mousedown', stopPropagation);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      modalDialog.removeEventListener('mousedown', stopPropagation);
    };
  }, [isOpen, modalRef, onClose]);
};

export default useModalBehavior;
